import { Injectable } from '@angular/core';

/*
  Generated class for the LocationLogicProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class LocationLogicProvider {

  constructor() {
    console.log('Hello LocationLogicProvider Provider');
  }

  private replaceAll(string: string, search: string, replacement: string): string {
    return string.split(search).join(replacement);
  }

  /**
   * Removes minus and transforms string to lowercase before comparison
   * @param pLocation 
   * @param pTarget 
   */
  public locationMatchesTarget(pLocation: string, pTarget: string): boolean {
    if (pLocation != null && pTarget != null) {
      if (this.replaceAll(pLocation,"-", "").toLowerCase() === this.replaceAll(pTarget,"-", "").toLowerCase()) {
        console.log('Scanned barcode [' + this.replaceAll(pLocation,"-", "").toLowerCase() + '] matches target [' + this.replaceAll(pTarget,"-", "").toLowerCase() + ']...');
        return true;
      } else
        console.log('Scanned barcode does not match [' + this.replaceAll(pLocation,"-", "").toLowerCase() + '] matches target [' + this.replaceAll(pTarget,"-", "").toLowerCase() + ']...');
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/providers/location-logic/location-logic.ts